import { Box, Button, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {H2} from "../../components/Typography";

const FlexBox = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
}));

const JustifyBox = styled(FlexBox)(() => ({
    maxWidth: 320,
    flexDirection: 'column',
    justifyContent: 'center',
}));

const IMG = styled('img')(() => ({
    width: '100%',
    marginBottom: '32px',
}));

const NotFoundRoot = styled(FlexBox)(() => ({
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh !important',
}));

const SessionOut = () => {
    const navigate = useNavigate();

    return (
        <NotFoundRoot>
            <JustifyBox>
                <IMG src="/assets/images/illustrations/session_out.gif" alt="" />

                <H2>Session OUT</H2>

                <Button
                    color="primary"
                    variant="contained"
                    sx={{ textTransform: 'capitalize' }}
                    onClick={() => navigate("/session/signin")}
                >
                   Login Again
                </Button>
            </JustifyBox>
        </NotFoundRoot>
    );
};

export default SessionOut;
